let usedBaseUrl: string

export const setupBaseUrl = (baseUrl: string) => {
  if (usedBaseUrl && usedBaseUrl !== baseUrl) {
    throw new Error(
      `Called setupBaseUrl with ${JSON.stringify(
        baseUrl
      )}, but it has already been called with ${JSON.stringify(usedBaseUrl)}`
    )
  }

  usedBaseUrl = baseUrl
  __webpack_public_path__ = `${baseUrl.replace(/\/+$/, '')}/`
}
